import { useRouter as useVueRouter, useRoute } from 'vue-router'

function useRouter() {
  const router = useVueRouter()
  const route = useRoute()
  
  // Maintain compatibility with Vue 2 router API
  return {
    ...router,
    currentRoute: route
  }
}

export default useRouter
